<template>
	<div class="container pt-5 my-5">
		<header class="jumbotron">
			<h3>Алтарь</h3>
		</header>
		<p class="text-center">
			<img src="//iwstatic.g.bsrv.su/resources/images/shrine11.jpg" width="150" height="106" /> <img src="//iwstatic.g.bsrv.su/resources/images/shrine15.jpg" width="150" height="106" />
		</p>
		<p><b>Алтарь</b> - строение, которое позволяет проводить дуэли, уменьшать время на восстановление героя после дуэли, проводить тренировочный бой, обменивать медали на карму и ланы. Максимальное количество уровней - 10.</p>
		<p><b>Особенности строения:</b></p>
	</div>
</template>

<style lang="css">

</style>

<script>
export default {
	name: 'WikiOpisAltar',
	computed: {
		currentUser(){
			return this.$store.state.user;
		},
	},
	/*mounted() {
		if (!this.currentUser) {
			this.$router.push('/login');
		}
	}*/
};
</script>